export const defaultToolConfig = [
  // State-only tool used by the map DrawToolbar flow.
  {
    name: 'Draw',
    title: 'Draw',
    icon: 'pencil-alt',
    toc: true,
    visible: false,
    fixedTop: true,
    targetLayer: null,
  },
  // Floating panels rendered by src/containers/Tools/ToolRegistry.tsx.
  {
    name: 'Legend',
    title: 'Legend',
    icon: ['fal', 'list-alt'],
    toc: true,
    visible: false,
    collapsed: false,
    positionX: null,
    positionY: null,
    minWidth: 230,
  },
  {
    name: 'LayerSettings',
    title: 'Layer Settings',
    icon: ['fal', 'cog'],
    toc: false,
    visible: false,
    collapsed: false,
    positionX: null,
    positionY: null,
    layer: null,
    minHeight: 568,
    minWidth: 389,
  },
  {
    name: 'GroupSettings',
    title: 'Group Settings',
    icon: ['fal', 'cog'],
    toc: false,
    visible: false,
    collapsed: false,
    positionX: null,
    positionY: null,
    group: null,
    minHeight: 492,
    minWidth: 389,
  },
  {
    name: 'MapViewSettings',
    title: 'Map View Settings',
    icon: ['fal', 'map-marked-alt'],
    toc: false,
    visible: false,
    collapsed: false,
    positionX: null,
    positionY: null,
    mapViewGroup: null,
    minHeight: 568,
    minWidth: 389,
  },
  {
    name: 'Notes',
    title: 'Notes',
    icon: ['fal', 'map'],
    toc: false,
    visible: false,
    collapsed: false,
    positionX: null,
    positionY: null,
    minWidth: 305,
  },
]
